export default class Styles {

  rules = {};

  constructor(rules = {}) {
    this.rules = rules;
  }

  setRule(key, value) {
    this.rules[key] = value;
  }

  setRules(rules) {
    for (const key in rules) {
      this.setRule(key, rules[key]);
    }
  }

  getRule(key) {
    return this.rules[key] || null;
  }

  /**
   * @param {boolean} tableColumnMode
   * @return {string}
   */
  getStyle(tableColumnMode = false) {
    return this.buildStyle(tableColumnMode ? this.getColumnModeRules() : this.getStyles());
  }

  /**
   * @param {array} rules
   * @return {string}
   */
  buildStyle(rules) {
    let style = '';

    for(const key in rules) {
      const value = rules[key];

      if (!value) continue;

      style += `${key}: ${value};`;
    }

    return style;
  }
  
  getStyles() {
    return this.rules;
  }

  getColumnModeRules() {
    let rules = JSON.parse(JSON.stringify(this.getStyles()));
    let newRules = {};

    const map = [
      {from: 'right', to: 'bottom'},
      {from: 'top', to: 'left'},
      {from: 'bottom', to: 'right'},
      {from: 'left', to: 'top'},
    ];
    const b = 'border';

    map.forEach(m => {
      ['style', 'width', 'color'].forEach(property => {
        let from = `${b}-${m.from}-${property}`;
        let to = `${b}-${m.to}-${property}`;
        if (rules[from]) {
          newRules[to] = rules[from];
          delete rules[from];
        }
      });
    })

    for (let key in newRules) {
      rules[key] = newRules[key];
    }

    return rules;
  }
}
